/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react"
import styled from "styled-components"
import StartButton from "../home/StartButton"
import Fade from "react-reveal/Fade"

export default function CompleteForm({
  setPage,
  setName,
  name,
  setQAAnimation,
  QAAnimation,
  summaryCount,
  setEmail,
  email,
  GetAndShare
}) {
  const [CanSubit, setCanSubit] = useState(false)

  const nameHolder = e => {
    const value = e.target.value
    setName(value)
  }
  const emailHolder = e => {
    const value = e.target.value
    setEmail(value)
  }

  const handleKeyDown = event => {
    event.preventDefault()

    submit()
  }

  useEffect(() => {
    name.length < 1 && GetAndShare.completeType.includes("name")
      ? setCanSubit(false)
      : setCanSubit(true)
  }, [emailHolder, nameHolder])

  const submit = () => {
    if (CanSubit === false) {
      return
    }
    {
      summaryCount()
      setQAAnimation(!QAAnimation)
      setTimeout(() => {
        setPage(pre => pre + 1)
      }, 3000)
    }
  }

  return (
    <Wrapper>
      <Title>完成測驗</Title>
      <Form className="completeForm" onSubmit={handleKeyDown}>
        {GetAndShare.completeType.includes("name") && (
          <Input
            type="text"
            placeholder={"請輸入你的名字"}
            onChange={nameHolder}
          />
        )}

        {GetAndShare.completeType.includes("email") && (
          <Input
            type="text"
            value={email}
            placeholder={"請輸入你的Email"}
            onChange={emailHolder}
          />
        )}
        <ButtonWrapper className={CanSubit === false ? "disable" : ""}>
          <Fade>
            <StartButton
              content="生成結果"
              onClick={submit}
              CanClick={CanSubit === false ? false : true}
            />
          </Fade>
        </ButtonWrapper>
      </Form>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  font-size: 300;
  color: #fff;
  z-index: 3;
  display: flex;
  flex-direction: column;
  gap: 30px;
  position: relative;
  &::before {
    content: "";
    width: 300px;
    height: 300px;
    background-color: #000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
    filter: blur(50px);
  }
  &:after {
    content: "";
    width: 400px;
    height: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid #00ffee92;
    border-radius: 50%;
    z-index: 0;
    backdrop-filter: blur(1.5px);
  }

  .completeForm {
    display: flex;
    flex-direction: column;
    gap: 30px;
    z-index: 1;

    align-items: center;
  }
`
const Title = styled.h2`
  font-size: 24px;
  text-align: center;
  z-index: 1;
`
const Input = styled.input`
  border: 1px solid #00fff0;
  border-radius: 8px;
  padding: 14px 14px;
  background-color: rgba(255, 255, 255, 0);
  width: 100%;
  font-size: 20px;
  color: #00fff0;
  text-align: center;
  font-weight: 700;
  transition: 0.3s;
  &::-webkit-input-placeholder {
    color: #00fff0;
    font-weight: 300;
  }
  &:focus {
    box-shadow: 0 0 20px #00fff0;
  }
`

const ButtonWrapper = styled.div`
  /* border: 1px solid #fff; */
  position: relative;
  max-width: 300px;
  width: 100%;
  padding: -0 12px;
  transition: all 0.3s;
  cursor: pointer;
  &.disable {
    opacity: 0.5;
    cursor: default;
    z-index: -1;
  }
`
const Form = styled.form``
